import { SxStyleProp } from 'theme-ui';

export const baseStyle: { [k: string]: SxStyleProp } = {
  mainContainer: {},
  title: {
    textAlign: 'center',
    marginBottom: ['30px', '110px'],
    maxWidth: [null, '947px'],
    marginX: 'auto',
    color: 'indigo.100',
  },
  mainRowContainer: {
    flexDirection: ['column', 'row'],
    alignItems: ['center', 'flex-start'],
    justifyContent: ['flex-start', 'center'],
  },
  mainRowContainerLeft: {
    flex: 1,
    justifyContent: 'center',
    marginRight: [null, '60px'],
    marginBottom: ['30px', '0px'],
    maxHeight: ['674px'],
    width: '100%',
    maxWidth: ['698px'],
  },
  image: {
    img: {
      objectFit: 'contain !important',
    },
    width: '100%',
    maxWidth: 'unset !important',
  },
  mainRowContainerRight: {
    flex: 1,
    width: '100%',
    maxWidth: ['310px', '560px'],
    marginLeft: [null, '60px'],
    textAlign: 'left',
  },
  contentBody: {
    marginBottom: ['45px', '25px'],
  },
  cta: {
    margin: ['0 auto', '0'],
  },

  sameSizeColumn: {
    flexBasis: ['100%', '50%'],
    width: ['100%', '50%'],
  },
};
